import { useTranslation } from "next-i18next";

import { Modal } from "common/ui/Modal";
import { Paragraph } from "common/ui/Paragraph";
import { Skeleton } from "common/ui/Skeleton";

import { useUnit } from "common/middleware/hooks";

interface DealCancelledModalProps {
  close: () => void;
  listingId: number;
  cancelledBy: string;
  onAcknowledge: () => Promise<void>;
}

export const DealCancelledModal = ({ close, listingId, cancelledBy, onAcknowledge }: DealCancelledModalProps) => {
  const { t } = useTranslation("common");
  const { unit, isUnitLoading } = useUnit(listingId);

  const address = `${unit?.address?.unitNumber ? `${unit?.address?.unitNumber} - ${unit?.address?.street}` : unit?.address?.street}, ${unit?.address.city} ${unit?.address?.province}`;

  return (
    <Modal
      title={isUnitLoading ? t("dealCancelledModal.dealCancelled") : t("dealCancelledModal.title", { address })}
      close={close}
      primaryAction={{
        text: t("dealCancelledModal.acknowledge"),
        onClick: async () => {
          await onAcknowledge();
          close();
        },
      }}
    >
      {isUnitLoading ? (
        <Skeleton type="p1" width={200} />
      ) : (
        <Paragraph variant="p1">
          {t("dealCancelledModal.body", {
            address,
            cancelledBy: cancelledBy || t("dealCancelledModal.buyer"),
          })}
        </Paragraph>
      )}
    </Modal>
  );
};
